// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3fatX","imageUploader":"EGiftCard_imageUploader__1mi6p"};